import React, { Component } from 'react';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import { Typography, MenuItem, Select } from '@material-ui/core';
import withStyles from '@material-ui/core/styles/withStyles';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';

import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";

import { connect } from 'react-redux';

import ImgNoFound from './ImgNoFound';
import axios from 'axios';


const theme1 = createMuiTheme({
  overrides: {
    MuiSelect: {
      select: {
        "&:focus": {
          background: "$labelcolor"
        }
      }
    }
  }
});

class TestSelect4 extends Component {

  state = {
    groupId: '',
    groups: []
  }

  handleChange = (event) => {
    const { groups } = this.props;
    let selectedGroup = [{ name: '' }];
    if (event.target.value != '') {
      selectedGroup = groups.filter(gr => gr.id === event.target.value);
    }
    this.setState({ groupId: event.target.value })
    const { user: { email } } = this.props;
    const data = {
      email: email,
      // domain: '',
      id: event.target.value,
      groupName: selectedGroup[0].name
    }
    // console.log(data)
    this.props.onGroupSend(data)
  }

  componentDidMount = ()=>{
    const {selectedGroup} = this.props;
    if(selectedGroup){
      this.setState({groupId:selectedGroup.id})
    }
  }

  render() {
    const { groups} = this.props;
    groups.sort((a, b) => (a.name > b.name) ? 1 : -1)
    const { classes } = this.props;
    return (
      <div>
        {groups ?
          <div>
            {/* <FormControl> */}
            {/* <MuiThemeProvider theme={theme1}> */}
            <Select
              className='select-mu'
              value={this.state.groupId}
              // name='asdads'
              onChange={this.handleChange}
              displayEmpty
              disableUnderline
              variant='outlined'
              classes={{
                root: classes.root,
              }}
              MenuProps={MenuProps}
            >
              <MenuItem value="">None</MenuItem>

              {groups.map((group) => {
                return (
                  <MenuItem
                    value={group.id}
                    key={group.id}
                  >
                    {group.img ?
                      <img className='select-img' src={group.img}></img>
                      : <ImgNoFound />}
                    <Typography variant="body1" style={{ marginLeft: 10 }}>
                      {group.name}
                    </Typography>
                    {group.type === 'public channel' ? <Typography style={{
                      marginLeft: 5,
                      color: 'grey'
                    }}>(Channel)</Typography> : <Typography style={{
                      marginLeft: 5,
                      color: 'grey'
                    }}>(
                    {group.members && group.members.length} members)
                    </Typography>}
                  </MenuItem>
                )
              })}
            </Select>
            {/* </MuiThemeProvider> */}
            {/* <FormHelperText>chose group</FormHelperText> */}

            {/* </FormControl> */}

          </div> : <div>No Groups</div>
        }
      </div>
    );
  }
}

const mapStateToProps = ({ user }) => ({ user });

const style = {
  root: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    border: '1px solid lightgrey',
    borderRadius: 7,
    minHeight: 53,
    padding: '0 20px',
  },
}

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: 250,
    },
  }
};



export default connect(mapStateToProps)(withStyles(style)(TestSelect4))



// WEBPACK FOOTER //
// ./src/containers/widget/components/TestSelect4.js